(function() {

	var ProductComparePage = function() {
		this.initAddToCart();
	};

	ProductComparePage.prototype = {
		
		initAddToCart: function() {
			$('form.product-add-to-cart').each(function(i, elem) {
				new C.AddToCart(elem);
			});
		},
		
		submitRemove: function(product_id) {
			let numProducts = $('#product-compare-table .product-cell').length

			this.removeFromCookie(product_id)

			if (numProducts > 1) {
				$("#removeProduct input").each(function() {
					if ($(this).val() == product_id) {
						$(this).remove();
					}
				});
				$("#removeProduct").submit();
			} else {
				let prevSearchURL = $('#continue-shopping').attr('href')
				window.location.href = prevSearchURL
			}
		},

		removeFromCookie: function(product_id) {
			let compare_product_ids = Cookies.get('compare_product_ids').split(',')
			let removeIdx = compare_product_ids.indexOf(product_id)
			compare_product_ids.splice(removeIdx, 1)
			Cookies.set('compare_product_ids', compare_product_ids.join(','))
		}
		
	};

	C.ProductComparePage = ProductComparePage;

})();
